<example-shell
  exampleId="header-groups" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Header groups"
    [columns]="headerGroupColumns"
    [data]="orders"
    [pagination]="true"
    [paginationPerPage]="5">
  </stackline-data-table>
</example-shell>
